package linkerpangoquipdb

import kotlin.Long
import kotlin.String

public data class Auth_table(
  public val user_id: String?,
  public val session_token: String?,
  public val refresh_token: String?,
  public val created_at: Long?,
)
